import React from 'react';
import NoteTagList from '../theme/buttons/NoteTag';
import Input from '../theme/forms/Input';

export default class FilterDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: this.props.filters,
      sortDsc: this.props.filters.sortDsc,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.setState({
        filters: this.props.filters,
        sortDsc: this.props.filters.sortDsc,
      });
    }
  }

  render() {
    let filters = [...(this.state.filters.noteTags || [])];

    return (
      <>
        <div className={'flx flx_column'} style={{ position: 'relative' }}>
          <div style={{ marginBottom: '-16px' }} className={'flx flx_row space_between'}>
            <div className={'flx flx_row'}>
              <i
                className={`fa fa-arrow-${
                  this.state.sortDsc ? 'down' : 'up'
                } px-0 py-0 mb-0 mr-2 primary-text button button-clear`}
                onClick={() => {
                  this.setState({
                    sortDsc: !this.state.sortDsc,
                  });
                  this.props.handleSortDirectionChange();
                }}
              ></i>
              <Input
                type={'select'}
                style={{
                  border: 'none',
                  background: 'none',
                  color: '#1a569d',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '0px',
                  marginBottom: '0px',
                }}
                value={this.state.filters.sortBy}
                // defaultValue={this.state.filters.sortBy}
                onChange={(val) => this.props.handleSortUpdate(val)}
                options={this.state.filters.sortFields}
              />
            </div>
            {!this.props.hideModalButton && (
              <div
                className={'button button-clear mb-0 px-0 py-2 primary-text'}
                onClick={this.props.openFilterModal}
              >
                Edit Filters
              </div>
            )}

          </div>

          <Input
            className={'full-width'}
            noBottomMargin={true}
            style={{ marginBottom: '.5rem' }}
            type={'text'}
            showClear={true}
            isClearShown={this.state.filters.keyword.length > 0}
            onChange={this.props.handleSearchChange}
            placeholder={this.props.searchPlaceholder || 'Search'}
            handleClear={() => this.props.handleSearchChange('')}
            {...this.props.value}
          />
        </div>
        <NoteTagList notes={filters} />
      </>
    );
  }
}
